module.exports = __webpack_public_path__ + "static/media/telegram.b9dceb58.svg";